// @ts-nocheck

import * as Types from '../../../../../graphql/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import { gql } from '@apollo/client';
export type GetImportColumnsQueryVariables = Types.Exact<{
  entityType: Types.ImportEntityTypeModel;
  importTypeId?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;

export type GetImportColumnsQuery = { importColumns: { columns?: Array<ImportColumnDataFragment | null> | null } };

export type ImportColumnDataFragment = {
  __typename: 'ImportColumnModel';
  label?: string | null;
  urn?: string | null;
  values?: Array<{ value?: string | null; label?: string | null } | null> | null;
};

export const ImportColumnDataFragmentDoc = gql`
    fragment ImportColumnData on ImportColumnModel {
  __typename
  label
  urn
  values {
    value
    label
  }
}
    ` as unknown as DocumentNode<ImportColumnDataFragment, unknown>;
export const GetImportColumnsDocument = gql`
    query GetImportColumns($entityType: ImportEntityTypeModel!, $importTypeId: String) {
  importColumns(entityType: $entityType, importTypeId: $importTypeId) {
    columns {
      ...ImportColumnData
    }
  }
}
    ${ImportColumnDataFragmentDoc}` as unknown as DocumentNode<GetImportColumnsQuery, GetImportColumnsQueryVariables>;
